/* eslint-disable no-unused-vars */
import React from 'react';
import * as S from './TableBody.styled';
import { Loader } from 'components';
import { TableRow } from './components/TableRow';
import { reportUniqueFieldsList } from 'constants';
import { useSelector } from 'react-redux';

export const TableBody = ({
  visibleRows,
  data,
  TABLE_ROW_HEIGHT,
  isFetching,
  currentRequestType$,
  hideInstallsColumn,
}) => {
  const tableGrouping =
    useSelector((state) => state.publisherReportsFiltersTable.tableGrouping) || {};
  const isGrouping = tableGrouping[currentRequestType$.value];

  if (isFetching)
    return (
      <tbody>
        <tr>
          <td colSpan='7'>
            <Loader.Local delay={0} />
          </td>
        </tr>
      </tbody>
    );

  return (
    <tbody>
      {!data.length ? (
        <tr>
          <td colSpan='7' style={{ textAlign: 'center', height: '100px' }}>
            No records to display
          </td>
        </tr>
      ) : null}
      {data?.slice(0, visibleRows)?.map((item, index) => {
        return (
          <TableRow
            key={item[reportUniqueFieldsList[currentRequestType$.value]]}
            item={item}
            isGrouping={isGrouping}
            currentRequestType$={currentRequestType$}
            TABLE_ROW_HEIGHT={TABLE_ROW_HEIGHT}
            hideInstallsColumn={hideInstallsColumn}
          />
        );
      })}
    </tbody>
  );
};
